import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home';
import Audio from '@/views/Audio';
import Loading from '@/views/Loading';
import Swiper from '@/views/Swiper';
import Tab from '@/views/Tab';
import Signature from '@/views/Signature';
import Uploader from '@/views/Uploader';
import MessageBox from '@/views/MessageBox';

import UI from '@/views/ui/Home';
import UIFlex from '@/views/ui/Flex';
import UIPanel from '@/views/ui/Panel';
import UIList from '@/views/ui/List';
import UIButton from '@/views/ui/Button';
import UIIcon from '@/views/ui/Icon';
import UIFrom from '@/views/ui/Form';
import UIModal from '@/views/ui/Modal';
import UILabel from '@/views/ui/Label';
import UISearch from '@/views/ui/Search';
import UISchedule from '@/views/ui/Schedule';
Vue.use(Router);
export default new Router({
  routes: [
    {
      path: '/',
      redirect: 'Home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/audio',
      name: 'Audio',
      component: Audio
    },
    {
      path: '/loading',
      name: 'Loading',
      component: Loading
    },
    {
      path: '/swiper',
      name: 'Swiper',
      component: Swiper
    },
    {
      path: '/tab',
      name: 'Tab',
      component: Tab
    },
    {
      path: '/signature',
      name: 'Signature',
      component: Signature
    },
    {
      path: '/uploader',
      name: 'Uploader',
      component: Uploader
    },
    {
      path: '/messagebox',
      name: 'MessageBox',
      component: MessageBox
    },
    {
      path: '/ui',
      component: UI,
      children: [
        {
          path: 'flex',
          name: 'UIFlex',
          component: UIFlex
        },
        {
          path: 'panel',
          name: 'UIPanel',
          component: UIPanel
        },
        {
          path: 'list',
          name: 'UIList',
          component: UIList
        },
        {
          path: 'button',
          name: 'UIButton',
          component: UIButton
        },
        {
          path: 'icon',
          name: 'UIIcon',
          component: UIIcon
        },
        {
          path: 'form',
          name: 'UIFrom',
          component: UIFrom
        },
        {
          path: 'modal',
          name: 'UIModal',
          component: UIModal
        },
        {
          path: 'label',
          name: 'UILabel',
          component: UILabel
        },
        {
          path: 'search',
          name: 'UISearch',
          component: UISearch
        },
        {
          path: 'schedule',
          name: 'UISchedule',
          component: UISchedule
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js